import { Solution } from "./Solutions";
import User from "./User";

export type Lesson = {
  id: string;
  url?: string;
  created_at: number;
  updated_at: number;
  state: LessonState;
  approver?: User;
  learned: string;
  headline: string;
  summary?: string;
  mitigation?: string;
  causes: Cause[];
  categories?: Category[];
  frequency_score?: number;
  impact_score?: number;
  recurrence_score?: number;
  time_lost?: number;
  annual_time_lost?: number;
  origin?: string;
  comments?: number;
  solutions?: Solution[];
};

export enum LessonState {
  draft,
  review,
  approved,
  rejected
}

export type Cause = {
  issues: string[];
  category: Category;
}

export type Category = {
  id: string;
  name: string;
  causes: number;
  severities: Severity[];
}

export type Severity = {
  count: number[];
  perceptions: number[];
}